import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { aesKeyValidator, encryptedKeyByRsaKeyValidator, publicKeyValidator, signedEncryptedKeyByRsaKeyValidator, signedEntityByRsaKeyValidator, } from '#validation';
const WorkspaceCryptoBaseSchema = z.object({
    workspaceSecretKey: aesKeyValidator.optional(),
    ssoGroupsPublicKey: publicKeyValidator,
    sSsoGroupsPublicKeyByAdminKey: signedEntityByRsaKeyValidator,
    eSsoGroupsPrivateKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    eSsoGroupsPrivateKeyByEveryoneKey: encryptedKeyByRsaKeyValidator,
});
export const EnsureSsoCryptoSchema = WorkspaceCryptoBaseSchema.extend({
    seSsoSecretKeyByAdminKey: signedEncryptedKeyByRsaKeyValidator,
    sSsoSecretKeyByAdminKey: signedEntityByRsaKeyValidator,
});
export const EnsureWorkspaceCryptoSchema = WorkspaceCryptoBaseSchema.extend({
    seWorkspaceSecretKeyByAdminKey: signedEncryptedKeyByRsaKeyValidator,
    sWorkspaceSecretKeyByAdminKey: signedEntityByRsaKeyValidator,
});
export class EnsureSsoCryptoDto extends createZodDto(EnsureSsoCryptoSchema) {
}
export class EnsureWorkspaceCryptoDto extends createZodDto(EnsureWorkspaceCryptoSchema) {
}
